module.exports = __webpack_public_path__ + "static/img/013.95261ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/013.png
// module id = o9ek
// module chunks = 0